module.exports = __webpack_public_path__ + "static/media/8.question.5f30b568.mp4";